import { useContext } from 'react';

import { SoundContext } from './SoundProvider';

const useSoundProvider = () => {
  const context = useContext(SoundContext);
  if (!context) throw new Error('useSoundProvider must be used within a SoundProvider');

  return context;
};

export default useSoundProvider;
